/**
 * 接入环信 by cjr
 *
 * @param {*} param0 配置对象
 */

window.easemobim = window.easemobim || {};
const HxService = function ({
    // 自定义按钮的class
    sClass,
    // 设置客服接待组id
    groupId = '44a908d8-7c5c-4701-9697-9462f0863e39',
    // 配置信息
    configInfo = {},
    click = () => {}
}) {
    this._isClick = true;
    this.configInfo = ({
        userId = 0,
        lessonId = 0,
        classId = 0,
        // 班级
        className = '',
        // 班主任
        teacher = '',
        // 昵称
        uname = '',
        // 真实姓名
        realname = '',
        // 开班时间
        classopenTime = '',
        // 作业答案
        projectAnswerUrl = ''
    }, config) => ({
        visitor: {
            trueName: realname,
            userNickname: uname,
            description:
                `userID:${
                    userId || '未获取到'
                }; 课程ID:${
                    lessonId
                }; 班级ID:${
                    classId
                }; 班级名称：${
                    className
                }; 开班时间：${
                    classopenTime
                }; 班主任：${
                    teacher
                }; 作业答案：${
                    projectAnswerUrl
                }`
        },
        hide: config.hide,
        autoConnect: config.autoConnect,
        onmessage: config.onmessage ? config.onmessage() : function (){},
        onready: config.ready ? config.ready() : function (){}
    });
    const script = document.createElement('script');
    script.id = 'hxScript';
    script.src = `//kefu.easemob.com/webim/easemob.js`;
    document.body.appendChild(script);
    script.onload = () => {
        // eslint-disable-next-line
        easemobim.config = configInfo && this.configInfo(configInfo.visitor, configInfo.config);
    };

    // 取得自定义的元素
    const el = document.querySelector(sClass);
    el.addEventListener('click', e => {
        e.stopPropagation();
        if (this._isClick) {
            this._isClick = false;
            click();
        }
        // eslint-disable-next-line
        easemobim.bind({
            configId: groupId
        });
    }, false);

};

export default HxService;
